import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p508605706808791040',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
